import { AuthService } from './../../auth.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  Input,
  HostListener,
} from '@angular/core';
import { Location } from '@angular/common';

import { MenuService } from 'src/app/system-common/services/menu.service';
import { SettingService } from '../services/setting.service';

import { HeaderService } from '../services/header.service';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/Notifications/services/notifications.service';
@Component({
  selector: 'sym-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.css'],
  host: {
    '(document:click)': 'onDropdownOutsideClick($event)',
  },
})
export class TopHeaderComponent implements OnInit {
  @ViewChild('dropdown') dropdown: ElementRef;
  @ViewChild('dropdownMenu') dropdownMenu: ElementRef;
  @ViewChild('dropdownMenuBtn') dropdownMenuBtn: ElementRef;
  @Output() menuToggle = new EventEmitter<void>();
  public totalNotificationCount: number;
  public notificationList = [];
  public notificationCountResData: any = [];
  public messagesNotificationResponseData = [];
  public totalMsgCount;
  public announcementList;
  public unreadMessageCount = 0;
  public unreadAnnouncementCount = 0;
  public userName: string;
  public userImage: string;
  public userImageName: string;
  public imageUrl: string;
  public isProfileOpen: boolean;
  public isNotification: boolean;

  constructor(
    public menuService: MenuService,
    public settingService: SettingService,
    private location: Location,
    public authService: AuthService,
    public headerService: HeaderService,
    public router: Router,
    public notificationService: NotificationService
  ) {
    this.headerService.isShow = false;
    this.totalNotificationCount = 0;
    this.unreadMessageCount = 0;
    this.unreadAnnouncementCount = 0;
    let parsedUserImage: string | null = null;
    this.userName =
      this.menuService.getUserLoginData() != undefined &&
      this.menuService.getUserLoginData()['UserName'] != undefined
        ? this.menuService.getUserLoginData()['UserName']
        : JSON.parse(this.settingService.getSessionStorageValue('USER'));
    const raw = this.settingService.getSessionStorageValue('UserImage');
    parsedUserImage =
      raw !== undefined && raw !== 'undefined' && raw != null ? JSON.parse(JSON.stringify(raw)) : null;
    this.userImage = this.menuService.getUserLoginData()['UserImage'] ?? parsedUserImage ?? null;
    this.userImage = this.hexToBase64(this.userImage);

    let parsedUserImageName: string | null = null;
    const raw1 = this.settingService.getSessionStorageValue('UserImageName');
    parsedUserImageName =
      raw1 !== undefined && raw1 !== 'undefined' && raw1 != null ? JSON.parse(JSON.stringify(raw1)) : null;
    this.userImageName = this.menuService.getUserLoginData()['UserImageName'] ?? parsedUserImageName ?? null;

    const extension = this.userImageName?.split('.')[1]?.toLowerCase();
    let mimeType = 'image/png';
    if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';
    this.imageUrl = this.userImage == null ? null : `data:${mimeType};base64,${this.userImage}`;
  }

  ngOnInit(): void {
    setTimeout(() => {
      // this.getMessagesNotification('MESSAGE');
      this.getCountNotification();
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {}

  /**
   * @ignore
   */
  goBack(): void {
    this.headerService.errorCount = undefined;
    this.location.back();
  }
  /**
   * This emitts the selected option from the header.
   * @param buttonClicked selected option from the header.
   */
  onMoreOptionClicked(buttonClicked: { id: string; link: string }) {
    this.headerService.isOptionCalled = false;
    this.headerService.forwardOptionSelected(buttonClicked);
  }

  onDropdownOutsideClick(event) {
    if (this.dropdown != undefined) {
      if (!this.dropdown.nativeElement.contains(event.target)) {
        if (this.dropdownMenu.nativeElement.classList.contains('show')) {
          this.dropdownMenuBtn.nativeElement.click();
        }
      }
    }
  }

  headerChanges() {
    this.headerService.setPageDocumentTitle();
    return true;
  }

  // toggleMenu() {
  //   this.menuToggle.emit();
  // }

  public hexToBase64(hexString) {
    if (hexString == null) {
      return null;
    }

    if (!hexString || hexString.length % 2 !== 0) {
      throw new Error('Invalid hex string');
    }

    const bytes = new Uint8Array(hexString.length / 2);
    for (let i = 0, j = 0; i < hexString.length; i += 2, j++) {
      bytes[j] = parseInt(hexString.substr(i, 2), 16);
    }

    const binaryString = String.fromCharCode(...bytes);
    return btoa(binaryString);
  }

  getCountNotification() {
    this.notificationService.getCountNotification().subscribe((body) => {
      let response = JSON.parse(JSON.stringify(body));
      this.notificationCountResData.push(response.data.notificationsCount);

      for (let i = 0; i < this.notificationCountResData[0].length; i++) {
        const current = this.notificationCountResData[0][i];
        // if (current.notificationType == 'ANNOUNCEMENT' || current.notificationType === 'BIRTHDAY') {
        if (current.notificationType === 'BIRTHDAY') {
          this.notificationList.push(current.notificationType);
          this.totalNotificationCount += current.notificationCount || 0;
        }
      }
      this.getMessagesNotification('ANNOUNCEMENT');
    });
  }

  goToNotification(notification) {
    if (notification == 'LAPSEDPOLICIES') {
      this.router.navigate(['getLapsedPolicies']);
    } else if (notification == 'BIRTHDAY') {
      this.router.navigate(['getBirthday']);
    } else if (notification == 'ANNOUNCEMENT') {
      this.router.navigate(['getAnnouncement']);
    } else {
      console.log('Path not Found');
    }
  }

  getMessagesNotification(notificationType) {
    this.notificationService.getNotification(notificationType).subscribe(
      (body) => {
        let response = JSON.parse(JSON.stringify(body));
        if (response.data != undefined) {
          this.messagesNotificationResponseData = Object.values(response.data);
          this.totalMsgCount = this.messagesNotificationResponseData[0].length;
          if (notificationType === 'ANNOUNCEMENT') {
            // Store announcements list for ticker
            this.announcementList = this.messagesNotificationResponseData[0].map((msg) => {
              return {
                message: msg.announcemenName,
                date: msg.announcemenDate,
              };
            });
          }

          this.messagesNotificationResponseData[0].filter((msg) => {
            if (
              msg.notificationReadFlag == 'NO' ||
              msg.notificationReadFlag == ' ' ||
              msg.notificationReadFlag == undefined ||
              msg.notificationReadFlag == null
            ) {
              if (notificationType == 'MESSAGE') {
                this.unreadMessageCount = this.unreadMessageCount + 1;
              } else if (notificationType == 'ANNOUNCEMENT') {
                this.unreadAnnouncementCount = this.unreadAnnouncementCount + 1;
              }
            }
          });
        }
      },
      (error) => {
        console.log('Error:', error);
        this.notificationService.handleError(error);
      }
    );
  }

  goToProfile() {
    this.router.navigate(['profile']);
  }

  logout() {
    let headerTitle = SettingService.getInjector().get(HeaderService);
    if (headerTitle.pageHeader != undefined) {
      headerTitle.pageHeader.title = null;
      headerTitle.pageHeader.additionalInfo = null;
    }
    this.settingService.logoutUser();
  }

  toggleNotification(event: MouseEvent): void {
    event.stopPropagation();
    this.isProfileOpen = false;
    this.isNotification = !this.isNotification;
  }

  toggleProfile(event: MouseEvent): void {
    event.stopPropagation();
    this.isNotification = false;
    this.isProfileOpen = !this.isProfileOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;

    if (!target.closest('.profile-wrapper')) {
      this.isProfileOpen = false;
    }

    if (!target.closest('.notification-wrapper')) {
      this.isNotification = false;
    }
  }

  openMessageNotifications() {
    this.isNotification = false;
    this.isProfileOpen = false;
    this.router.navigate(['getMessages']);
  }

  navigateToChangePassword() {
    this.router.navigate(['change-password']);
  }

  // Add this method inside your component .ts file

  isToday(timestamp: number): boolean {
    if (!timestamp) return false;

    // Convert your API timestamp (in milliseconds) to a Date object
    const date = new Date(timestamp);

    const today = new Date();

    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }
}
